module.exports = __webpack_public_path__ + "static/media/18ECA13.656a976d.jpg";